<template>
  <div class="mianContain cdl_scollerStyle">
    <heard-c-d-l></heard-c-d-l>
    <keep-alive>
      <router-view :key="$route.fullpath"></router-view>
    </keep-alive>
    <b-footer></b-footer>
  </div>

</template>

<script>
  import bFooter from './footerBase/index'
  import heardCDL from './navTemp/index'
    export default {
        name: "index2",
      components: {bFooter, heardCDL}
    }
</script>

<style scoped>
  .mianContain {
    width: 100%;
  }
  /* 全局滚动条样式 */
  .cdl_scollerStyle::-webkit-scrollbar {
    width: 4px;
    /*height: 4px;*/
  }
  .cdl_scollerStyle::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.1);
    background: rgba(0,0,0,0.1);
  }
  .cdl_scollerStyle::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.1);
    border-radius: 0;
    background: rgba(0,0,0,0.1);
  }

</style>



// WEBPACK FOOTER //
// src/components/index2.vue